import { gql } from '@apollo/client';

export * from './markAsReadTasks.mutation.generated';

export const MARK_AS_READ_TASKS = gql`
  mutation markAsReadTasks($taskIds: [ID!]!) {
    markAsReadTasks(input: { taskIds: $taskIds }) {
      errors
      success
      tasks {
        id
      }
    }
  }
`;
